import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Grid, Card, CardContent, Typography, Button } from '@mui/material';
import { LocalShipping, Assignment, Warning, Inventory } from '@mui/icons-material';
import { ScreenFrame } from '../PrototypeShared';

export default function DashboardScreen() {
  return (
    <ScreenFrame
      title="Dashboard"
      actions={
        <Button component={Link} to="/prototype/profile" variant="outlined" size="small">
          Profile
        </Button>
      }
    >
      <Typography color="text.secondary" paragraph>
        Overview and quick actions. All cards are clickable.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Card component={Link} to="/prototype/incoming-deliveries" sx={{ textDecoration: 'none', color: 'inherit' }}>
            <CardContent>
              <LocalShipping color="primary" sx={{ mb: 1 }} />
              <Typography variant="h6">Incoming Deliveries</Typography>
              <Typography variant="body2" color="text.secondary">View and manage deliveries</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card component={Link} to="/prototype/audits" sx={{ textDecoration: 'none', color: 'inherit' }}>
            <CardContent>
              <Assignment color="primary" sx={{ mb: 1 }} />
              <Typography variant="h6">Audits</Typography>
              <Typography variant="body2" color="text.secondary">Audit list and new audit</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card component={Link} to="/prototype/recalls" sx={{ textDecoration: 'none', color: 'inherit' }}>
            <CardContent>
              <Warning color="primary" sx={{ mb: 1 }} />
              <Typography variant="h6">Recalls</Typography>
              <Typography variant="body2" color="text.secondary">Recall management</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card component={Link} to="/prototype/pallets" sx={{ textDecoration: 'none', color: 'inherit' }}>
            <CardContent>
              <Inventory color="primary" sx={{ mb: 1 }} />
              <Typography variant="h6">Pallets</Typography>
              <Typography variant="body2" color="text.secondary">Stock and pallet list</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Box sx={{ mt: 3 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>Quick links</Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          <Button component={Link} to="/prototype/production-planning" variant="outlined" size="small">Production Planning</Button>
          <Button component={Link} to="/prototype/shopfloor" variant="outlined" size="small">Shopfloor</Button>
          <Button component={Link} to="/prototype/processes" variant="outlined" size="small">Processes</Button>
          <Button component={Link} to="/prototype/help" variant="outlined" size="small">Help</Button>
        </Box>
      </Box>
    </ScreenFrame>
  );
}
